/**
 * Client environment — all vars come from Doppler via `doppler run`.
 * Required vars block app startup. Optional vars degrade gracefully.
 */

// Public landing stays auth-free. Clerk is optional and only loaded
// inside the /me and /edit islands (BK-199-4). Missing key = handoff login.
const REQUIRED_KEYS = [] as const;

export function normalizeEnvValue(value: string | undefined): string {
  return value?.replace(/(?:\\r|\\n)+$/g, "").trim() ?? "";
}

export function getMissingEnvKeys<
  TKey extends readonly string[],
>(keys: TKey, env: Partial<Record<TKey[number], string | undefined>>): TKey[number][] {
  return keys.filter((key) => !normalizeEnvValue(env[key]));
}

export const clientEnv = {
  VITE_API_URL: normalizeEnvValue(import.meta.env.VITE_API_URL),
  VITE_POSTHOG_KEY: normalizeEnvValue(import.meta.env.VITE_POSTHOG_KEY),
  VITE_POSTHOG_HOST: normalizeEnvValue(import.meta.env.VITE_POSTHOG_HOST),
  VITE_INTERNAL_PREVIEW_TOKEN: normalizeEnvValue(import.meta.env.VITE_INTERNAL_PREVIEW_TOKEN),
  VITE_CLERK_PUBLISHABLE_KEY: normalizeEnvValue(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY),
};

export const missingClientEnv = getMissingEnvKeys(REQUIRED_KEYS, clientEnv);

// Legacy — kept for backward compat
export const missingSupabaseEnv: string[] = [];
